import NiceModal from '@ebay/nice-modal-react';

import { Suspense, useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import Button from 'components/field/Button';
import Authorization from 'components/global/Authorization';
import Loading from 'components/global/Loading';
import PageHeader from 'components/global/PageHeader';
import Tabs from 'components/global/Tabs';

import PATHS, { mergePaths } from 'utils/paths';

import { faPlus } from '@fortawesome/pro-regular-svg-icons';

import StatusGroupTransitionsForm from './StatusGroupTransitions/StatusGroupTransitionsForm';
import StatusGroupForm from './StatusGroups/StatusGroupForm';
import DCStatusMappingForm from './StatusMapping/DCStatusMappingForm';
import OtoOrderStatusForm from './Statuses/OtoOrderStatusForm';

const HeaderButtons = () => {
	const { pathname } = useLocation();

	return (
		<>
			{pathname === mergePaths(PATHS.DC_STATUS_MANAGEMENT, PATHS.DC_STATUSES) && (
				<Authorization path="/modal/addOtoOrderStatus">
					<Button
						label="addStatus"
						icon={faPlus}
						lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/addOrder-icon.json.gz"
						variant="blue"
						className="addButton"
						onClick={() =>
							NiceModal.show(OtoOrderStatusForm, {
								mode: 'add'
							})
						}
					/>
				</Authorization>
			)}
			{pathname === mergePaths(PATHS.DC_STATUS_MANAGEMENT, PATHS.DC_STATUS_GROUPS) && (
				<Authorization path="/modal/addStatusGroup">
					<Button
						label="addStatusGroup"
						icon={faPlus}
						lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/addOrder-icon.json.gz"
						variant="blue"
						className="addButton"
						onClick={() =>
							NiceModal.show(StatusGroupForm, {
								mode: 'add'
							})
						}
					/>
				</Authorization>
			)}
			{pathname === mergePaths(PATHS.DC_STATUS_MANAGEMENT, PATHS.STATUS_GROUP_TRANSITIONS) && (
				<Authorization path="/modal/addAllowedGroupStatusTransition">
					<Button
						label="addStatusGroupTransition"
						icon={faPlus}
						lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/addOrder-icon.json.gz"
						variant="blue"
						className="addButton"
						onClick={() =>
							NiceModal.show(StatusGroupTransitionsForm, {
								mode: 'add'
							})
						}
					/>
				</Authorization>
			)}
			{pathname === mergePaths(PATHS.DC_STATUS_MANAGEMENT, PATHS.DC_STATUS_MAPPING_LIST) && (
				<Authorization path="/modal/addDCStatusMapping">
					<Button
						label="addStatusMapping"
						icon={faPlus}
						lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/addOrder-icon.json.gz"
						variant="blue"
						className="addButton"
						onClick={() =>
							NiceModal.show(DCStatusMappingForm, {
								mode: 'add'
							})
						}
					/>
				</Authorization>
			)}
		</>
	);
};
const DCStatusManagement = () => {
	const tabs = useMemo(
		() => [
			{
				label: 'statusMapping',
				path: mergePaths(PATHS.DC_STATUS_MANAGEMENT, PATHS.DC_STATUS_MAPPING_LIST)
			},
			{
				label: 'groupTransactions',
				path: mergePaths(PATHS.DC_STATUS_MANAGEMENT, PATHS.STATUS_GROUP_TRANSITIONS)
			},
			{
				label: 'groups',
				path: mergePaths(PATHS.DC_STATUS_MANAGEMENT, PATHS.DC_STATUS_GROUPS)
			},
			{
				label: 'statuses',
				path: mergePaths(PATHS.DC_STATUS_MANAGEMENT, PATHS.DC_STATUSES)
			}
		],
		[]
	);

	return (
		<div>
			<PageHeader
				lordIcon="https://storage.googleapis.com/tryoto-public/lottie-files-compressed/shippingPartners-icon-new.json.gz"
				title="DCStatusManagement">
				<HeaderButtons />
			</PageHeader>
			<Tabs data={tabs} checkURL />
			<Suspense fallback={<Loading />}>
				<Outlet />
			</Suspense>
		</div>
	);
};

export default DCStatusManagement;
